import axios from 'axios';

const API_URL = "/wattendws/index.php";
//const API_URL_LOCAL = "http://localhost:2727/wattendws/index.php";

class API {
  constructor() {
    let config = {
      headers: {
        Authorization: ""
      }
    };

    if ( window.location.href.indexOf( "localhost:3000" ) === -1 ) {
      config.baseURL = API_URL;
      config.proxy = {
        host: "localhost",
        port: 80
      };

    }

    else {
      config.proxy = {
        host: "localhost",
        port: 2727
      };
    }

    config = this.headers( config );
    let service = axios.create( config );
    service.interceptors.response.use( response => response, this.handleError );
    this.service = service;
  }

  headers( opt ) {
    let currentUser = JSON.parse( localStorage.getItem( 'currentUser' ) ) || {};
    
    currentUser.type = "Basic";
    currentUser.token = btoa( "root:teste123" );

    if ( currentUser && currentUser.type && currentUser.token ) {
      opt.headers.Authorization = currentUser.type + " " + currentUser.token;
    }

    return opt;
  }

  get( path ) {
    return this.service.get( path );
  }

  patch( path, data ) {
    return this.service.request( {
      method: 'PATCH',
      url: path,
      responseType: 'json',
      data: data
    } );
  }

  post( path, data ) {
    return this.service.request( {
      method: 'POST',
      url: path,
      responseType: 'json',
      data: data
    } );
  }

  put( path, data ) {
    return this.service.request( {
      method: 'PUT',
      url: path,
      responseType: 'json',
      data: data
    } );
  }

  delete( path, data ) {
    return this.service.request( {
      method: 'DELETE',
      url: path,
      responseType: 'json',
      data: data
    } );
  }


  log = ( l ) => {
    console.log( l );
  };

  setImageBackground = imgUrl => {
    let bgImage = new Image()
    bgImage.src = imgUrl;
    bgImage.onload = function () {
      document.body.style.backgroundImage = `url('${imgUrl}')`;
    };
  };

  handleError = ( error ) => {

    switch ( error.response && error.response.status ) {
      case 401:
        this.log( 401 + "Not Autorized", error );
        break;
      case 404:
        this.log( 404, error );
        break;
      default:
        this.log( 'error default', error.response );
        break;
    }
    return Promise.reject( error.response )
  }


}



export default new API();